/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_LiveInputs */

const vi_station_live = /** @type {(inputs: Station_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang nhận đơn`)
};

/**

* @param {Station_LiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_live = /** @type {((inputs?: Station_LiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_LiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_live(inputs)
});